import React, { FC } from 'react'
import { styled } from '@creditas/stylitas'

const CalendarContainer = styled.div`
  flex: 1;
  background-color: #fee;
  width: 336px;
`
const Calendar: FC<{ calendarIsVisible?: boolean }> = ({
  calendarIsVisible = false,
}) =>
  calendarIsVisible ? (
    <CalendarContainer>Calendar Goes Here</CalendarContainer>
  ) : (
    <></>
  )

export { Calendar }
